module.exports = __webpack_public_path__ + "static/title3.855b8aae98f5454fc4010b22c4be8adc.png";